// extracted by mini-css-extract-plugin
export default {"root":"BlurredBackgroundImage_root__+5qg6","image":"BlurredBackgroundImage_image__M29n1"};